import { Button } from '@bennows/boows-react';
import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNotificationSummaryQuery } from './useNotifications';

/**
 * The bell entry point in the app shell header (spec 50 §6.5, AC-50-036): its
 * accessible name states the unread count so a screen reader announces it
 * without the visual badge. Unread count refreshes every 60 s and on window
 * focus (`useNotificationSummaryQuery`). Failing the summary silently shows
 * no badge rather than an error state — the bell is a shortcut, not the
 * primary view (the `/notifications` list has its own error state).
 */
export function NotificationBell() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const summary = useNotificationSummaryQuery();
  const unread = summary.data?.unread_count ?? 0;

  return (
    <div className="notification-bell">
      <Button
        variant="ghost"
        iconOnly
        aria-label={unread > 0 ? t('notifications.bell.labelUnread', { count: unread }) : t('notifications.bell.label')}
        onClick={() => navigate('/notifications')}
      >
        <Bell aria-hidden="true" />
      </Button>
      {unread > 0 ? (
        <span className="notification-bell__badge" aria-hidden="true">
          {unread > 99 ? '99+' : unread}
        </span>
      ) : null}
    </div>
  );
}
